import { FormOutlined, GlobalOutlined } from '@ant-design/icons'
import { getRouteApi } from '@tanstack/react-router'
import { Space } from 'antd'
import CantileverButton from 'components/CantileverButton'
import { DrilldownDataContext } from 'features/drilldown/data/savedExplorationState/DrilldownExplorationContext'
import React, { useCallback, useContext } from 'react'

interface ExplorationNavigationButtonsProps {
  unlinkCurrentExploration?: () => void
}

export const ExplorationNavigationButtons: React.FC<
  ExplorationNavigationButtonsProps
> = ({ unlinkCurrentExploration }) => {
  const { siteId, orgId } = useContext(DrilldownDataContext)
  const { useNavigate } = getRouteApi('/explorer/$orgOrSiteID')
  const navigate = useNavigate()

  const handleOrganizationLevelNavigation = useCallback(() => {
    if (orgId) {
      navigate({
        to: '/explorer/$orgOrSiteID',
        params: { orgOrSiteID: orgId },
        replace: true,
        reloadDocument: true,
      })
    }
  }, [navigate, orgId])

  return (
    <Space orientation='vertical' size='small' style={{ width: '100%' }}>
      <CantileverButton
        onClick={unlinkCurrentExploration}
        style={{ width: '100%' }}>
        <FormOutlined />
        Open new exploration
      </CantileverButton>
      {!!siteId && !!orgId && (
        <CantileverButton
          onClick={handleOrganizationLevelNavigation}
          style={{ width: '100%' }}>
          <GlobalOutlined />
          Open new exploration for organization
        </CantileverButton>
      )}
    </Space>
  )
}
